import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Close mobile menu on resize or click outside
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 990) setIsMenuOpen(false);
    };
    const handleClickOutside = (e) => {
      if (!e.target.closest(".navbar")) setIsMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">FOX ACADEMY</Link>
      </div>
      <button
        className={`navbar-toggle ${isMenuOpen ? "open" : ""}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle navigation menu"
        aria-expanded={isMenuOpen}
      >
        <span />
        <span />
        <span />
      </button>
      <ul className={`nav-links ${isMenuOpen ? "show" : ""}`}>  
        <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Ballina</Link></li>
        <li><Link to="/kurset" onClick={() => setIsMenuOpen(false)}>Kurset</Link></li>
        <li><Link to="/stafi" onClick={() => setIsMenuOpen(false)}>Stafi</Link></li>
        <li><Link to="/rreth-nesh" onClick={() => setIsMenuOpen(false)}>Rreth Nesh</Link></li>
        <li><Link to="/kontakt" onClick={() => setIsMenuOpen(false)}>Kontakt</Link></li>
      </ul>
    </nav>
  );
}
